/* eslint-disable no-mixed-operators */
import { Dispatch } from "redux";
import {
    setData, setDocumentTypes, setChangedDepartment, setChangedDivisonAdmin,
    callbackUpdateReport, callbackRestartUploadWorkflow, callbackDeleteReport,
    setChangeSPFOwner,
    setSPFOLoading,
    setROULoading,
    setLLCoordinatorLoading
} from "./actions";
import Constants from "../../core/libraries/Constants";
import { getReport, updateReport, restartUpload, deleteReport } from "./services";
import { getDocumentTypes } from "../Upload/services";
import { getDirectDeps, getSuperiorDeps } from "../../services/idmServices";
import { IGetOrgInfoReq } from "../../services/type";
import { getLLDivisionAdmin } from "../../services/aadServices";
import { ILowerFirstCaseMetadata } from "./types";

export const getReportDispatch = (reportId: string, callback: any) => async (dispatch: Dispatch) => {
    let data = await getReport(reportId);
    dispatch(setData(data, callback));
};

export const getDocumentTypesDispatch = (uploadType: string) => async (dispatch: Dispatch) => {
    if (uploadType !== Constants.UPLOAD_TYPE.LL) {
        let data = await getDocumentTypes(Constants.TYPE_MASTER_LIST[uploadType]);
        if (data.length === 0) {
            data.push.apply(data, Constants.DOCUMENT_TYPE_MASTER_DATA[uploadType]);
        }
        else {
            let result: any[] = [];
            data.forEach((item: any) => {
                result.push({
                    key: item.Title,
                    text: item.Title
                });
            });
            data = result;
        }
        dispatch(setDocumentTypes(data));
    }
};

export const changeDepartmentDispatch = (getRouRequest: IGetOrgInfoReq, callback: any) => async (dispatch: Dispatch) => {
    // Set loading states
    dispatch(setROULoading(true));
    dispatch(setLLCoordinatorLoading(true));
    
    try {
        let data = await getSuperiorDeps(getRouRequest);
        dispatch(setChangedDepartment(data, callback));
    } catch (error) {
        // Reset loading states on error
        dispatch(setROULoading(false));
        dispatch(setLLCoordinatorLoading(false));
        throw error;
    }
};

export const changeSPFOwnerDispatch = (getSPFOwnerReq: IGetOrgInfoReq, callback: any) => async (dispatch: Dispatch) => {
    dispatch(setSPFOLoading(true));
    
    try {
        let data = await getDirectDeps(getSPFOwnerReq);
        dispatch(setChangeSPFOwner(data, callback));
    } catch (error) {
        dispatch(setSPFOLoading(false));
        throw error;
    }
};

export const changeDivisionAdminDispatch = (division: any, callback: any) => async (dispatch: Dispatch) => {
    dispatch(setLLCoordinatorLoading(true));
    console.log("Division changed to: ", division);
    try {
        let data = await getLLDivisionAdmin(division);
        dispatch(setChangedDivisonAdmin(data, callback));
    } catch (error) {
        dispatch(setLLCoordinatorLoading(false));
        throw error;
    }
};

export const updateReportDispatch = (report: any, callback: any) => async (dispatch: Dispatch) => {
    let data = await updateReport(report);
    dispatch(callbackUpdateReport(data, callback));
};

export const restartUploadWorkflow = (report: ILowerFirstCaseMetadata, callback: any) => async (dispatch: Dispatch) => {
    let data = await restartUpload(report);
    dispatch(callbackRestartUploadWorkflow(data, callback));
};

export const deleteReportDispatch = (reportId: string, callback: any) => async (dispatch: Dispatch) => {
    let isSuccess = await deleteReport(reportId);
    dispatch(callbackDeleteReport(isSuccess, callback));
};